import { h, Component } from 'preact';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import FilterStyled from 'components/pages/showtimes/filterStyled.js';
import pure from 'utils/pure';
import s from 'components/pages/showtimes/filters.sss';
import { getCopyWithParams } from 'utils/clientUtils';
import { condClass, sortObjectByOrder } from 'utils/utils';

export default @pure class Filters extends Component {

	render({ filters, totalScreeningsCount, filteredScreeningsCount, device, hidden, noText, copy, pageData }) {
		let filteredText = '';

		if (filteredScreeningsCount !== totalScreeningsCount && !noText) {
			let text = getCopyWithParams({
				COUNT: filteredScreeningsCount,
				TOTAL: totalScreeningsCount
			}, copy.$FILTER_RESULTS || '');
			filteredText = <div class={s.filteredText}>{text}</div>;
		}

		let displayedFilters = sortObjectByOrder(filters).filter(filter => filter.visible);

		let className = s.container + condClass(hidden, s.hidden);
		return (
			<div class={className}>
				{displayedFilters.map(filter => {
					let options = (filter && filter.options) || [];
					// Do not show the filter if only one option
					if (options.length <= 1) {
						return;
					}
					return <FilterStyled class={s.selectFilter} filter={filter} device={device} pageData={pageData} />;
				})}
				{filteredText}
			</div>
		);
	}
}
